<div class="example_outer_section">
    <div class="example_top_heading">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <h1><span class="OpenSansFonts">Trinka</span>であらゆる角度からライティングの質を改善</h1>
                    <p>研究者とテクニカルライターの皆様の英文ライティングをサポートする<span class="OpenSansFonts">AI</span>校正ツール<span class="OpenSansFonts">Trinka</span>。文法だけでなく、高度なライティングの要件を満たすよう英文をチェックし、効果的なコミュニケーションを可能にします。</p>
                </div>
            </div>
        </div>
    </div>

    <div class="exapmle_cards_heading">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <h3>高度なチェックで文法ミスをゼロに</h3>
                    <p>一般的な英文チェックツールでは検知されない学術論文とテクニカルライティング特有の文法ミスも、<span class="OpenSansFonts">Trinka</span>なら確実にチェック。</p>
                </div>
            </div>
        </div>
    </div>

    <div class="example_boxs">
        <div class="container">
            <div class="row">
                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h4>主語と動詞の活用一致</h4>
                        <p>Therefore, these results suggest that the hypersecretion of CRH and endorphin
                            <span>suppress</span>
                            <span class="right_word">suppresses</span> the secretion of LH and FSH from the pituitary gland.
                        </p>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h4>単語の選択</h4>
                        <p>The statistical analyses were performed <span>with</span> <span class="right_word">using</span> a statistical analysis software (SAS).</p>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h4>前置詞</h4>
                        <p>Recent years have seen an increase <span>of</span> <span class="right_word">in</span> exudation of various organic acids.</p>
                    </div>
                </div>

                <!-- <div class="col-md-12">
                    <div class="example_box_contents">
                        <h4>Subject-verb disagreement</h4>
                        <p><span><span class="OpenSansFonts">Trinka</span></span> is your personal <span>AI editor</span> for all your academic writing
                            needs. <span><span class="OpenSansFonts">Trinka</span></span> is your personal <span>AI editor</span> for all your academic
                            writing needs.</p>
                    </div>
                </div> -->

                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h4>形容詞の用法</h4>
                        <p>The group receiving the placebo treatment had the <span>most</span> highest improvement in sleep scores.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- <div class="borderd_line"></div> -->

    <div class="exapmle_cards_heading background_color_changes">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <h3>ジャーナル読者に喜ばれる英文に</h3>
                    <p>文章のトーンや文体をチェックし、論文のスタイルガイドに準拠した英文に校正。<span class="OpenSansFonts">Trinka</span>で、世界中の研究者に読んでもらえる文書が作れます。</p>
                </div>
            </div>
        </div>
    </div>

    <div class="example_boxs boxs_margin background_color_changes">
        <div class="container">
            <div class="row">
                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h4>簡潔さ</h4>
                        <p>Utilities would continue to <span>have the obligation</span> <span class="right_word">be
                                obliged</span> to serve retail customers.</p>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h4>フォーマルな文章トーン</h4>
                        <p>The <span>average</span> <span class="right_word">mean</span> age of the study group was 54.2 years (range: 890 years).</p>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h4>単語の選択</h4>
                        <p>The assembly <span>abrogated</span> <span class="right_word">arrogated</span> to itself the right to make changes.</p>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h4>スタイルガイド</h4>
                        <p>Substance <span>abuse</span> <span class="right_word">use disorder</span> has been a major public health concern.</p>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <!-- <div class="borderd_line"></div> -->


    <div class="exapmle_cards_heading">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <h3>各専門分野に応じた的確な校正</h3>
                    <p><span class="OpenSansFonts">Trinka</span>は学問領域・研究分野ごとの特殊な表現や語法を収録しているため、それを無視した修正や変更は加えません。</p>
                </div>
            </div>
        </div>
    </div>

    <div class="example_boxs boxs_margin">
        <div class="container">
            <div class="row">
                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h4>コンピューターサイエンス</h4>
                        <p>In our study, 90% of the users expressed the need for a <span>dialogue</span> <span class="right_word">dialog</span> box to alert them to a pending update.</p>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h4>物理学</h4>
                        <p>By contrast, the <span>effect</span> <span class="right_word">effects</span> of the Mach number and <span class="">heat</span> specific <span class="right_word">heat</span> ratio contribute little to the aerodynamic performance.
                        </p>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h4>医学</h4>
                        <p>Our study matched for age, <span>gender</span> <span class="right_word">sex</span>, ethnicity, and BMI, marijuana use was associated with higher abdominal visceral fat.
                        </p>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h4>経済学</h4>
                        <p>The estimated natural rate, based on the <span>past</span> history of the data, plummets by nearly 2
                            <span>percent</span> <span class="right_word">percentage</span> points.
                        </p>
                        <!-- <p>Studies have shown that organizational culture and <span>organizational</span> environment
                            now meet work-life policies.
                        </p> -->
                    </div>
                </div>

            </div>
        </div>
    </div>

    <!-- <div class="borderd_line"></div> -->


</div>